<section *ngIf="data">
  <div *ngIf="data.type == 'submit'" class="alert alert-info"><mmp5-mm-icons [icon]="['fa-solid','fa-spinner']"></mmp5-mm-icons>{{ data.message }}</div>
  <div *ngIf="data.type == 'error'" class="alert alert-danger">{{ data.message }}</div>
  <div *ngIf="data.type == 'success'" class="alert alert-success">{{ data.message }}</div>
</section>
